// EditUserButton.tsx
import { memo, useMemo } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { ButtonPopup } from '../../../../features/popup/ButtonPopup/ButtonPopup';
import AddUserPopupAdapter from '../../../../features/users/AddUserPopup/AddUserPopupAdapter';
import { UsersTablet } from '../../../../models/Users/Users';
import styles from './style.module.css';
import cn from 'classnames';
import { UsersRequest } from '../../../../store/reducers/UsersSlice';

interface EditUserButtonProps {
  record: UsersTablet;
  callRequest: UsersRequest;
}

export const EditUserButton = memo(
  ({ record, callRequest }: EditUserButtonProps) => {
    const extra = useMemo(
      () => ({
        icon: <EditOutlined />,
        isEditing: true,
        selectedUser: record,
        modalKey: `edit-${record.id}`,
        callRequest,
      }),
      [record, callRequest],
    );

    return (
      <div
        className={cn(styles.tableCell, styles.tableCellLast)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <ButtonPopup
            title=""
            isSquared={true}
            isTableButton={true}
            PopupComponent={AddUserPopupAdapter}
            extra={extra}
          />
        </div>
      </div>
    );
  },
);

EditUserButton.displayName = 'EditUserButton';
